import { getLineHeightInPx } from './inject-mobile-line-height-class';
import { getStyleProp } from './css-property-utils';
export const recalculateLineHeight = (element, fallbacks) => {
    const lineHeightInPx = getLineHeightInPx(element, fallbacks);
    return element.css('line-height', `${parseInt(lineHeightInPx || '', 10)}px`);
};
export const lineHeightExplicitInheritance = (element, fallbacks) => {
    const lineHeight = getStyleProp(element, 'line-height', fallbacks.css);
    return element.css('line-height', lineHeight);
};
//# sourceMappingURL=recalculate-line-height.js.map